export var sizeTextSizeMapping = {
  tiny: 'intermediate',
  small: 'regular',
  medium: 'medium',
  large: 'medium'
};